<button
  id="attachedResourceButton"
  [class.btn-icon-text]="alone"
  [class.only-icon]="!alone"
  [class.waiting]="waiting"
  class="transparent accent"
  mat-flat-button
  [opacTooltip]="'tooltip.download' | translate"
  appStopPropagation
  (click)="downloadResource()">
  <ng-container *ngIf="!waiting">
    <span class="odilo-icon">download</span>
    <span class="text" *ngIf="alone">{{ 'general.download' | translate }}</span>
  </ng-container>

  <ng-container *ngIf="waiting">
    <mat-spinner [diameter]="20"></mat-spinner>
    <span class="text"> {{ status | translate }} {{ progress | number: '1.2-2' }}<span *ngIf="progress">%</span> </span>
  </ng-container>
</button>
